// Import of creatApp from Vue 3 bundler.
import { createApp } from 'vue/dist/vue.esm-bundler.js';

// App imports.
import newsApp from './vue/news.js';
import projectsApp from './vue/projects.js';
import partnersApp from './vue/partners.js';
import newsletterApp from './vue/newsletter.js';
import contactApp from './vue/contact.js';
import downloadApp from './vue/download.js';

document.addEventListener('DOMContentLoaded', () => {
    // Mounting containers listing and DOM targeting.
    const newsOverviewContainer = document.getElementById('news-overview');

    const newsWidgetContainers = document.querySelectorAll('.news-overview');

    const projectOverviewContainer = document.getElementById('project-overview');

    const projectWidgetContainers = document.querySelectorAll('.project-overview');

    const partnerOverviewContainer = document.getElementById('partner-overview');

    const newsletterContainers = document.querySelectorAll('.newsletter-form');

    const contactformContainers = document.querySelectorAll('.contact-form');

    const downloadContainers = document.querySelectorAll('.download-form');

    // For each app, only build the Vue instance if the targeted element is present and mount the app on the targeted element.
    if (newsOverviewContainer) {
        createApp(newsApp).mount(newsOverviewContainer);
    }

    newsWidgetContainers.forEach(container => {
        createApp(newsApp).mount(container);
    });

    if (projectOverviewContainer) {
        createApp(projectsApp).mount(projectOverviewContainer);
    }

    projectWidgetContainers.forEach(container => {
        createApp(projectsApp).mount(container);
    });

    if (partnerOverviewContainer) {
        createApp(partnersApp).mount(partnerOverviewContainer);
    }

    newsletterContainers.forEach(container => {
        createApp(newsletterApp).mount(container);
    });

    contactformContainers.forEach(container => {
        createApp(contactApp).mount(container);
    });

    downloadContainers.forEach(container => {
        createApp(downloadApp).mount(container);
    });
});
